import request from '@/utils/request';

export function flowSubmit(gainEid) {
    return request({
        url: `/position/gains/flow/${gainEid}`,
        method: 'put'
    });
}

export function reAudit(gainEid) {
    return request({
        url: `/position/gains/flow/${gainEid}/reaudit`,
        method: 'put'
    });
}